module.exports = __webpack_public_path__ + "img/promocode.77c612df.svg";